import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import TWControls from 'components/controls/TWControls'
import { Form, useForm } from 'components/controls/useForm'
import Message from 'components/Message'

const UserUpdatePassword = ({ updatePassword, externalError, setExternalError }) => {
	const [showOldPassword, setShowOldPassword] = useState(false)
	const [showNewPassword, setShowNewPassword] = useState(false)
	const [showNewPasswordCopy, setShowNewPasswordCopy] = useState(false)

	const initialFValues = {
		id: 0,
		oldPassword: '',
		newPassword: '',
		newPasswordCopy: '',
	}

	const validate = () => {
		let temp = { ...errors }
		temp.oldPassword = values.oldPassword ? '' : 'Old password required.'
		temp.newPassword = values.newPassword ? '' : 'New password is required.'

		temp.newPasswordCopy =
			values.newPassword === values.newPasswordCopy ? '' : 'Passwords must match.'

		setErrors({
			...temp,
		})

		return Object.values(temp).every(x => x === '')
	}

	const { values, errors, setErrors, handleInputChange, resetForm } = useForm(
		initialFValues,
		false,
		validate,
	)

	function handleChange(e) {
		setExternalError('')
		handleInputChange(e)
	}

	const submitHandler = e => {
		e.preventDefault()
		if (validate()) {
			updatePassword(values, resetForm)
		}
	}

	const allFieldsFilled =
		values.oldPassword &&
		values.newPassword &&
		values.newPasswordCopy &&
		values.newPassword === values.newPasswordCopy

	return (
		<Form onSubmit={submitHandler}>
			<div>
				<div className="relative">
					<TWControls.Input
						name="oldPassword"
						label="Old Password"
						value={values.oldPassword}
						onChange={handleChange}
						error={errors.oldPassword}
						type={showOldPassword ? 'text' : 'password'}
					/>
					<button
						type="button"
						className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
						aria-label="toggle password visibility"
						onClick={() => setShowOldPassword(!showOldPassword)}
					>
						{showOldPassword ? <EyeOff className="w-5 h-5 text-gray-500" /> : <Eye className="w-5 h-5 text-gray-500" />}
					</button>
				</div>
				{externalError && <Message variant="danger">{externalError}</Message>}
				<div className="relative">
					<TWControls.Input
						name="newPassword"
						label="New Password"
						value={values.newPassword}
						onChange={handleChange}
						error={errors.newPassword}
						type={showNewPassword ? 'text' : 'password'}
					/>
					<button
						type="button"
						className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
						aria-label="toggle password visibility"
						onClick={() => setShowNewPassword(!showNewPassword)}
					>
						{showNewPassword ? <EyeOff className="w-5 h-5 text-gray-500" /> : <Eye className="w-5 h-5 text-gray-500" />}
					</button>
				</div>
				<div className="relative">
					<TWControls.Input
						name="newPasswordCopy"
						label="Confirm New Password"
						value={values.newPasswordCopy}
						onChange={handleChange}
						error={errors.newPasswordCopy}
						type={showNewPasswordCopy ? 'text' : 'password'}
					/>
					<button
						type="button"
						className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
						aria-label="toggle password visibility"
						onClick={() => setShowNewPasswordCopy(!showNewPasswordCopy)}
					>
						{showNewPasswordCopy ? <EyeOff className="w-5 h-5 text-gray-500" /> : <Eye className="w-5 h-5 text-gray-500" />}
					</button>
				</div>
				{allFieldsFilled && (
					<div
						id="UserUpdatePassword__Actions"
						className="flex flex-row items-center justify-center gap-4 mt-4"
					>
						<TWControls.Button size="small" type="submit" text="Update" />
					</div>
				)}
			</div>
		</Form>
	)
}

export default UserUpdatePassword
